<template>
	<b-link :href="`mailto:${adminEmail}`" class="btn btn-primary">
		<slot>Contact Admin</slot>
	</b-link>
</template>

<script>
	export default {
		name: "contact-admin-button",
		inject: ["profileSvc"],
		computed: {
			adminEmail() {
				if (!this.profileSvc.user.company) return "support@limeiq.com";

				if (
					this.profileSvc.user.company_admin_emails &&
					0 < this.profileSvc.user.company.company_admin_emails.length
				)
					this.profileSvc.user.company.company_admin_emails[0];

				return "support@limeiq.com";
			},
		},
	};
</script>
